
export const StyleSheet = {
    DashboardLayoutCSS: { lg: 4, pl: { xl: 30, lg: 30, md: 'none', sm: 'none', xs: 'none' } },
    outletCSS: { minHeight: 'calc(100vh - 120px)', boxShadow: 4, }
}
